import styled from 'styled-components/macro';

import TableBase from '@components/common/core/Utils/Table';

export const PaginateWrapper = styled.div`
  margin-left: auto;
`;

export const KitTable = styled(TableBase)``;
